import Swiper from "swiper";
import { initIntersectionObserver, updateHoverSliders } from "@plugins";
import jquery from "jquery";

const $ = jquery;

window.hoverSliders = [];

$(document).ajaxSuccess(() => initHoverSliders());

window.addEventListener("load", () => initHoverSliders());
window.addEventListener("resize", updateHoverSliders());

function initHoverSliders() {
    const hoverSliders = document.querySelectorAll("[data-card-hover-slider]");

    if (hoverSliders) {
        for (const slider of hoverSliders) {
            initIntersectionObserver(slider, initHoverSlider);
        }
    }
}

function initHoverSlider(slider) {
    const swiperParent = slider.parentNode;
    const parentPromotion = swiperParent.querySelector(".js-card-with-promotion");
    const swiperContainer = slider.querySelector(".js-card-hover-slider-container");
    const swiperPagination = slider.querySelector(".js-pagination-hover");

    const swiper = new Swiper(swiperContainer, {
        allowTouchMove: true,
        // spaceBetween: 20,
        slidesPerView: 1,
        // nested: true,

        // Для перелистывания на мобильных устройствах
        speed: 0,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },

        pagination: {
            el: swiperPagination,
        },

        breakpoints: {
            768: {
                allowTouchMove: false,
            },
        },
    });

    if (parentPromotion) {
        const slides = slider.querySelectorAll(".swiper-slide");

        swiper.on("slideChange", () => {
            const slide = slides[swiper.realIndex];

            if (slide?.querySelector(".js-card-hover-product-info")) {
                parentPromotion.setAttribute("style", "display: none;");
            } else {
                parentPromotion.removeAttribute("style");
            }
        });
    }

    slider.addEventListener("mouseout", (evt) => {
        if (!slider.contains(evt.relatedTarget)) {
            swiper.slideTo(0);
        }
    });

    const bullets = swiperPagination.querySelectorAll(".swiper-pagination-bullet");

    for (let i = 0; i < bullets.length; i++) {
        const bullet = bullets[i];

        bullet.addEventListener("mouseenter", () => {
            swiper.slideTo(i);
        });
    }

    // Исключаем повторную инициализацию
    slider.removeAttribute("data-card-hover-slider");

    window.hoverSliders.push(swiper);
}
